import Vue from 'vue'
import VueI18n from 'vue-i18n'
import EmailCapture from './src/components/pages/email_capture.vue'
import './vee-validate'
import messages from './translations'

import {
  MsHeader,
  MsButton,
  MsConvoInput,
  MsCheckbox,
  MsLink,
  MsListGroup,
  MsIcon,
  MsImage,
  MsPromotionSnippet,
} from '@moneysmart/cargo-vue'

Vue.use(MsHeader)
Vue.use(MsButton)
Vue.use(MsConvoInput)
Vue.use(MsCheckbox)
Vue.use(MsLink)
Vue.use(MsListGroup)
Vue.use(MsIcon)
Vue.use(MsImage)
Vue.use(MsPromotionSnippet)
Vue.use(VueI18n)

document.addEventListener('DOMContentLoaded', () => {
  const element = document.getElementById("email-capture")
  const locale = element.dataset.locale

  Vue.prototype.$locale = locale

  const i18n = new VueI18n({
    locale: locale || 'en',
    messages
  });

  const app = new Vue({
    el: element,
    component: { EmailCapture },
    i18n,
    render: h => h(EmailCapture, {
      props: {
        pageInfo: JSON.parse(element.dataset.page_info),
        pageConfig: JSON.parse(element.dataset.capture_page_config),
        trackingEvent: element.dataset.tracking_event,
        pageViewEvent: element.dataset.page_view_event,
        trackingData: JSON.parse(element.dataset.tracking_data),
        emailCaptureAnalyticsData: JSON.parse(element.dataset.email_capture_analytics_data),
        emailCapturePageViewData: JSON.parse(element.dataset.email_capture_page_view_data),
        emailTriggerPath: element.dataset.email_trigger_path,
        redirectionUrl: element.dataset.redirection_url,
        iecpEnableSkip: element.dataset.iecp_enable_skip,
        consentTag: element.dataset.consent_tag,
        regionCode: element.dataset.region_code,
        campaignId: element.dataset.campaign_id,
        isPostRequest: element.dataset.is_post_request === 'true',
      },
    })
  })
})
